// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2t4kl","buttons":"RemoveExpirationActionButtons_buttons__15WSV"};